import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=7eefd9bc&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=7eefd9bc&scoped=true&lang=scss&"
import style1 from "./resource.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eefd9bc",
  null
  
)

export default component.exports